import { useNavigate } from "react-router-dom"
import { useGetAllAnimalEventTypesQuery } from "@/features/events/animal-events/api/event-types-api.ts"
import { NEW_ANIMAL_EVENT_VIEW } from "@/features/events/animal-events/routes/route-list.ts"
import { type GestationCalendar } from "@/features/gestational-calendar/types/calendar-types.ts"
import {
  FP_QUERY_PARAMS,
  GESTATION_CALENDAR_CONSTS,
} from "@/features/gestational-calendar/utils/gestation-calendar-consts.ts"

export const useNavigateBirthEvent = () => {
  const navigate = useNavigate()
  const { data: eventTypes } = useGetAllAnimalEventTypesQuery({})

  return (gestationalCalendar: GestationCalendar) => {
    const calvingCalendarActivity = gestationalCalendar.entries.find(
      (entry) => entry.event.metadata?.is_birth_event,
    )

    const birthEvent =
      eventTypes &&
      Object.values(eventTypes).find((event) => {
        return event.name === GESTATION_CALENDAR_CONSTS.Birth
      })

    const searchParams = new URLSearchParams()

    searchParams.append(FP_QUERY_PARAMS.ANIMAL_ID, gestationalCalendar.animal)
    searchParams.append(
      FP_QUERY_PARAMS.GESTATION_CALENDAR_ID,
      gestationalCalendar.id,
    )

    if (calvingCalendarActivity?.id) {
      searchParams.append(
        FP_QUERY_PARAMS.GESTATION_CALENDAR_ENTRY_ID,
        calvingCalendarActivity.id,
      )
    }
    if (birthEvent?.id) {
      searchParams.append(FP_QUERY_PARAMS.EVENT_TYPE_ID, birthEvent.id)
    }

    navigate(`${NEW_ANIMAL_EVENT_VIEW}?${searchParams.toString()}`)
  }
}
